import React from 'react';
import ClassReport from './ClassReport';

export default ClassReport;
